import { type MetaFunction } from '@remix-run/node'
import { Link } from '@remix-run/react'

export const meta: MetaFunction = () => [
	{ title: 'Insurance for Uber and Lyft Drivers' },
	{
		name: 'description',
		content: 'Learn about special coverage for ride sharing drivers',
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<Link to="/" prefetch="intent" className="text-blue-600 underline">
				Home
			</Link>{' '}
			&rarr;{' '}
			<Link
				to="/frequently-asked-questions/"
				className="text-blue-600 underline"
				prefetch="intent"
			>
				Frequently Asked Questions
			</Link>
			<br />
			<br />
			<h1 className="py-3 text-4xl font-black">
				Insurance for Uber and Lyft Drivers
			</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				<strong>
					How does driving for a ride sharing / transportation network company
					("TNC") such as Uber or Lyft affect my auto insurance coverage?
				</strong>
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				New York State personal auto policies are not designed to cover you when
				you are using your vehicle in a ride sharing business venture. Your
				policy contains exclusions for this type of use and you should exercise
				extreme caution. NY State law requires that TNC companies provide a
				certain amount of coverage when you are engaging in ride sharing.
			</p>
		</main>
	)
}
